export default __webpack_public_path__ + "static/media/dashboard.d774b26e.svg";